// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__tDUzs"};